/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { useAmp } from 'next/amp';

const Loading = ({ mobile, desktop }) => {
  const { isMobile } = useDeviceScreen();
  const isAmp = useAmp();
  const width = (isAmp || isMobile) ? mobile.width : desktop.width;
  const height = (isAmp || isMobile) ? mobile.height : desktop.height;

  return !isMobile ? (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="1" y="35" rx="0" ry="0" width="544" height="21" />
      <rect x="1" y="70" rx="0" ry="0" width="320" height="3" />
      <rect x="1" y="93" rx="0" ry="0" width="150" height="20" />
      <rect x="1" y="140" rx="5" ry="5" width="310" height="15" />
      <rect x="1" y="160" rx="5" ry="5" width="310" height="15" />
      <rect x="1" y="180" rx="5" ry="5" width="310" height="15" />
      <rect x="1" y="200" rx="5" ry="5" width="310" height="15" />
      <rect x="335" y="70" rx="0" ry="0" width="320" height="3" />
      <rect x="335" y="93" rx="0" ry="0" width="150" height="20" />
      <rect x="335" y="140" rx="5" ry="5" width="310" height="15" />
      <rect x="335" y="160" rx="5" ry="5" width="310" height="15" />
      <rect x="335" y="180" rx="5" ry="5" width="310" height="15" />
      <rect x="335" y="200" rx="5" ry="5" width="310" height="15" />
      <rect x="669" y="70" rx="0" ry="0" width="320" height="3" />
      <rect x="669" y="93" rx="0" ry="0" width="150" height="20" />
      <rect x="669" y="140" rx="5" ry="5" width="310" height="15" />
      <rect x="669" y="160" rx="5" ry="5" width="310" height="15" />
      <rect x="669" y="180" rx="5" ry="5" width="310" height="15" />
      <rect x="669" y="200" rx="5" ry="5" width="310" height="15" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="1" y="35" rx="0" ry="0" width="470" height="21" />
      <rect x="1" y="70" rx="0" ry="0" width="320" height="3" />
      <rect x="1" y="93" rx="0" ry="0" width="150" height="20" />
      <rect x="1" y="140" rx="5" ry="5" width="310" height="15" />
      <rect x="1" y="160" rx="5" ry="5" width="310" height="15" />
      <rect x="1" y="180" rx="5" ry="5" width="310" height="15" />
      <rect x="1" y="200" rx="5" ry="5" width="310" height="15" />
    </ContentLoader>
  );
};

Loading.propTypes = {
  mobile: PropTypes.object,
  desktop: PropTypes.object,
};

export default Loading;
